module.exports = __webpack_public_path__ + "public/Icons/getStartedArrowDark.svg?cd81a719";